// src/pages/packingBatch/components/FormatSelectorModal.jsx
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './FormatSelectorModal.module.css';

const FormatSelectorModal = ({ isOpen, onClose, onSelectFormat }) => {
  const { t } = useLocalization();

  if (!isOpen) return null;

  const handleFormatClick = (formatId) => {
    onSelectFormat(formatId);
  };

  const formats = [
    {
      id: '102x76',
      icon: '🏷️',
      title: t('packingBatch.labelFormatVertical'),
      description: t('packingBatch.labelFormatDesc'),
      dimensions: '76mm × 102mm'
    },
    {
      id: '102x76-h',
      icon: '🏷️',
      title: t('packingBatch.labelFormatHorizontal'),
      description: t('packingBatch.labelFormatDesc'),
      dimensions: '102mm × 76mm'
    },
    {
      id: 'a4-four',
      icon: '📄',
      title: t('packingBatch.a4Format'),
      description: t('packingBatch.a4FormatDesc'),
      dimensions: 'A4 (4 per page)'
    },
    {
      id: 'a4-four-landscape',
      icon: '📰',
      title: t('packingBatch.a4FormatLandscape'),
      description: t('packingBatch.a4FormatLandscapeDesc'),
      dimensions: 'A4 Landscape (4 per page)'
    },
    {
      id: '102x76-h-qr',
      icon: '🏷️',
      title: t('packingBatch.labelFormatHorizontalQr'),
      description: t('packingBatch.labelFormatHorizontalQrDesc'),
      dimensions: '102mm × 76mm (Long Airwaybill + QR)'
    },
    {
      id: '102x76-h-extended',
      icon: '🏷️',
      title: t('packingBatch.labelFormatHorizontalExtended'),
      description: t('packingBatch.labelFormatHorizontalExtendedDesc'),
      dimensions: '102mm × 76mm'
    }
  ];

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>{t('packingBatch.selectPrintFormat')}</h3>
          <button onClick={onClose} className={styles.closeButton}>
            ×
          </button>
        </div>
        
        <div className={styles.formatOptions}>
          {formats.map((format) => (
            <button
              key={format.id}
              onClick={() => handleFormatClick(format.id)}
              className={styles.formatOption}
            >
              <div className={styles.formatIcon}>{format.icon}</div>
              <div className={styles.formatDetails}>
                <strong>{format.title}</strong>
                <p>{format.description}</p>
                <span className={styles.dimensions}>{format.dimensions}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FormatSelectorModal;